<script>
  import { blurOnClick } from '../../../js/blurOnClick';
  import { trackLinkClick } from '../../../js/trackLinkClick';

  export let id = undefined;
  export let icon = undefined;
  export let title = undefined;
  export let url = '#';
  export let linkStyle = 'primary';
  export let width = 'auto';
</script>

<a
  {id}
  href={url}
  class="ButtonLink {linkStyle}"
  style="width: {width};"
  on:blur
  on:focus
  use:blurOnClick
  use:trackLinkClick={{ id, title, url }}
>
  {#if icon && icon.s3BaseUrl && icon.name}
    <div class="icon" style="--icon-url: url('{icon.s3BaseUrl}{icon.name}.svg')"></div>
  {/if}
  <span class="title">{title}</span>
</a>

<style>@charset "UTF-8";
.ButtonLink {
  cursor: pointer;
  appearance: none;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  display: inline-block;
  width: auto;
  height: auto;
  min-height: 0;
  max-height: none;
  min-width: 0;
  max-width: none;
  margin: 0;
  padding: 10px 10px;
  border: none;
  border-radius: 4px;
  background: transparent;
  color: var(--color-text, #1a1a1a);
  font-family: "Square Sans Text VF", "Square Sans Text", "Helvetica", "Arial", "Hiragino Kaku Gothic Pro", "ヒラギノ角ゴ Pro W3", "メイリオ", meiryo, "ＭＳ Ｐゴシック", sans-serif;
  font-size: 16px;
  line-height: 28px;
  font-weight: var(--font-weight-medium, 500);
  letter-spacing: normal;
  text-align: center;
  vertical-align: middle;
  text-decoration: none;
  white-space: nowrap;
  user-select: none;
  -webkit-user-drag: none;
  -webkit-tap-highlight-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1), background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
}
.ButtonLink:focus {
  outline: none;
}

.primary {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  color: #fff;
  background-color: var(--color-theme, #006aff);
}
.primary:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
.primary::-moz-focus-inner {
  border: 0;
}
.primary:focus {
  outline: none;
}
.primary::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-theme-focus, #05c);
  border-radius: 0;
  opacity: 0;
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.primary:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
@media (hover: hover) {
  .primary:hover::before {
    opacity: 1;
    transform: scale(1);
  }
}
.primary > * {
  position: relative;
}

.secondary {
  position: relative;
  overflow: hidden;
  -webkit-tap-highlight-color: transparent;
  color: var(--color-theme, #006aff);
  box-shadow: inset 0 0 0 1px var(--color-theme, #006aff);
}
.secondary:focus-visible:not(:active) {
  outline-offset: 2px;
  outline: 2px auto Highlight;
  outline: 2px auto -webkit-focus-ring-color;
}
.secondary::-moz-focus-inner {
  border: 0;
}
.secondary:focus {
  outline: none;
}
.secondary::before {
  content: "";
  pointer-events: none;
  display: block;
  position: absolute;
  inset: 0;
  background-color: var(--color-highlight, rgba(26, 26, 26, 0.1));
  border-radius: 0;
  opacity: 0;
  transition: opacity 150ms cubic-bezier(0.4, 0, 0.2, 1), transform 150ms cubic-bezier(0.4, 0, 0.2, 1);
}
.secondary:focus:not(:active)::before {
  opacity: 1;
  transform: scale(1);
}
.secondary > * {
  position: relative;
}

.icon {
  height: 24px;
  width: 24px;
  background-color: var(--color-theme, #006aff);
  mask: var(--icon-url) no-repeat center;
}

.title {
  position: relative;
}</style>
